import { render, staticRenderFns } from "./ecosystemPage.vue?vue&type=template&id=fa711eaa&scoped=true&"
import script from "./ecosystemPage.vue?vue&type=script&lang=js&"
export * from "./ecosystemPage.vue?vue&type=script&lang=js&"
import style0 from "./ecosystemPage.vue?vue&type=style&index=0&id=fa711eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa711eaa",
  null
  
)

export default component.exports